import React, { useEffect } from "react";
import "./styles/Footer.css";

const Footer = ({ user }) => {
  useEffect(() => {
    console.log("Footer -> User:", user);
  }, [user]);

  if (!user?.valid_to) {
    return (
      <footer className="footer-main text-center py-4">
        <p>Validity information not available</p>
      </footer>
    );
  }

  // Convert valid_to to a Date object
  const validToDate = new Date(user.valid_to);
  const today = new Date();

  // Calculate how many days are left
  const diffTime = validToDate.getTime() - today.getTime();
  const daysLeft = Math.max(Math.ceil(diffTime / (1000 * 60 * 60 * 24)), 0);

  // Format date as dd-mm-yyyy
  const formattedDate = `${String(validToDate.getDate()).padStart(2, "0")}-${String(
    validToDate.getMonth() + 1
  ).padStart(2, "0")}-${validToDate.getFullYear()}`;

  return (
    <footer>
      <div className="footer-main text-center py-4">
        <div className="footer-bottom">
          <p>
            <strong>{daysLeft}</strong> Days Left (Next Renewal Date:{" "}
            {formattedDate})
          </p>
        </div>
        <p>Powered by <a href="https://www.fostererp.com" target="_blank">Foster ERP</a></p>
        <p>
          Copyright © Foster Digital Technology Pvt Ltd | All Rights
          Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
